import React, { useState, useRef } from 'react';
import { Configurations } from '@hpi-sox/hpstellar-core';
import { Typography, Button, List, ListItem } from '@hpi-sox/hpstellar-core/visId';
import { ChevronRight } from '@hpi-sox/hpstellar-veneer-icons';
import HardBundleModal from './hard-bundle-modal';
import withPageComponents from '../../../../page/components/with-page-components';
import Icon from '../../../../ui/components/icon';
import { scrollToSpecsAndConditionallyLockView } from '../../../util';
import './hard-bundle-items.less';

const MAX_VISIBLE_BUNDLE_ITEMS = 3;

const HardBundleItems = ({
    productInitial,
    bundleSpecs,
    ctaText = 'Go to full specs list',
    ctaBundleText = 'View all products',
}) => {
    const { bundlePrimarySKU, bundleComponents = [] } = productInitial || {};
    const [modalOpen, setModalOpen] = useState(false);
    const hasScrolledToSpecs = useRef(null);

    const clickFullSpecsList = () => {
        scrollToSpecsAndConditionallyLockView(hasScrolledToSpecs && hasScrolledToSpecs.current, {
            onComplete: () => {
                try {
                    hasScrolledToSpecs.current = true;
                } catch (e) {}
            },
        });
    };

    return (
        <>
            {bundleComponents.map((component, idx) => {
                const { name, sku, quantity, thumbnail, keyPoints, catentryId } = component;
                const isPrimary = catentryId === bundlePrimarySKU;
                if (idx >= MAX_VISIBLE_BUNDLE_ITEMS) {
                    return null;
                }
                return (
                    <div className="hard-bundle-item" key={`${sku}-${idx}`}>
                        <Typography variant="list" className="item-quantity">
                            {quantity}x
                        </Typography>
                        {thumbnail && <img className="item-thumbnail" src={thumbnail} alt={`${name} thumbnail`} />}
                        <div className="item-content">
                            <Typography variant="body1" className="item-details">
                                {name}
                            </Typography>
                            {keyPoints && keyPoints.length > 0 && isPrimary && (
                                <List className="bundle-spec-list">
                                    {keyPoints.reduce((items, point, pointIdx) => {
                                        if (typeof point === 'string' && point.length > 0) {
                                            items.push(
                                                <ListItem
                                                    className="bundle-spec-list__item"
                                                    key={`${sku}-point-${pointIdx}`}
                                                >
                                                    {point}
                                                </ListItem>,
                                            );
                                        }

                                        return items;
                                    }, [])}
                                </List>
                            )}
                        </div>
                    </div>
                );
            })}
            {bundleComponents.length > MAX_VISIBLE_BUNDLE_ITEMS && (
                <div className="bundle-view-all-row">
                    <Typography variant="list" tag="span" className="bundle-view-all-count">
                        {bundleComponents.length - MAX_VISIBLE_BUNDLE_ITEMS}x
                    </Typography>
                    <div className="bundle-view-all-icon">
                        <Icon name="soldto" size={46} />
                    </div>
                    <Button
                        circularIcon
                        endIcon={<ChevronRight size={16} />}
                        theme="accent"
                        variation="tertiary"
                        tag="a"
                        onClick={() => setModalOpen(true)}
                    >
                        {ctaBundleText}
                    </Button>
                </div>
            )}
            <Button theme="accent" variation="tertiary" className="hard-bundle-cta" onClick={clickFullSpecsList}>
                {ctaText}
            </Button>
            <HardBundleModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                bundleComponents={bundleComponents}
                bundleSpecs={bundleSpecs}
            />
        </>
    );
};

const HardBundleContainer = ({ label = 'Bundle includes', productInitial, pdpTechSpecs }) => {
    const { bundleComponents } = productInitial || {};
    const { bundleSpecs = [] } = pdpTechSpecs || {};

    if (!bundleComponents || bundleComponents.length === 0 || !bundleSpecs || bundleSpecs.length === 0) {
        return null;
    }

    return (
        <Configurations
            className="hard-bundle-section"
            label={label}
            dividerPosition="top"
            content={<HardBundleItems productInitial={productInitial} bundleSpecs={bundleSpecs} />}
        />
    );
};

export default withPageComponents(HardBundleContainer, { components: ['productInitial', 'pdpTechSpecs'] });
